export default __webpack_public_path__ + "static/media/sim_new_white.6e0c4348.jpg";